import { render, staticRenderFns } from "./PreReceiveTab.vue?vue&type=template&id=62c72638&scoped=true"
import script from "./PreReceiveTab.vue?vue&type=script&lang=js"
export * from "./PreReceiveTab.vue?vue&type=script&lang=js"
import style0 from "./PreReceiveTab.vue?vue&type=style&index=0&id=62c72638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c72638",
  null
  
)

export default component.exports